import axios from 'axios';

export default {

    texts: {},

    loadTexts() {
        axios.get('/api/texts/')
            .then(response => {
                this.texts = response.data;
            })
            .catch(error => {
                console.log(error);
            });
    },

    getText(string, domain = 'base') {
        if(typeof(this.texts[domain]) === 'undefined') {
            return '';
        }

        if(typeof(this.texts[domain][string]) === 'undefined') {
            return '';
        }

        return this.texts[domain][string];
    }

};